import { ComponentType } from 'react';

import { translation, formatToReactComponent, TranslatedComponent } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import Column from 'bloko/blocks/column';
import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import { useChatikLink } from 'src/hooks/useChatikLink';
import { CareerServiceStatus, ApplicantService } from 'src/types/applicantServices';

import Awaiting from 'src/pages/ApplicantServicesOrder/components/CareerService/Awaiting';
import Closed from 'src/pages/ApplicantServicesOrder/components/CareerService/Closed';
import CreateRequest from 'src/pages/ApplicantServicesOrder/components/CareerService/CreateRequest';
import EditRequest from 'src/pages/ApplicantServicesOrder/components/CareerService/EditRequest';
import PrepareResume from 'src/pages/ApplicantServicesOrder/components/CareerService/PrepareResume';
import WorkDone from 'src/pages/ApplicantServicesOrder/components/CareerService/WorkDone';

import styles from './index.less';

const STATUS_COMPONENT_MAP: Record<CareerServiceStatus, ComponentType> = {
    [CareerServiceStatus.CreateRequest]: CreateRequest,
    [CareerServiceStatus.Awaiting]: Awaiting,
    [CareerServiceStatus.PrepareResume]: PrepareResume,
    [CareerServiceStatus.WorkDone]: WorkDone,
    [CareerServiceStatus.Closed]: Closed,
};

const TrlKeys = {
    chatikText: 'applicantServices.order.chatik.text',
    chatikLink: 'applicantServices.order.chatik.link',
};

const CareerServiceOrder: TranslatedComponent = ({ trls }) => {
    const order = useSelectorNonNullable(({ careerServiceOrder }) => careerServiceOrder);
    const orderStatus = order.status;
    const pathname = useSelectorNonNullable((state) => state.router.location.pathname);
    const availableEditUrls = Object.values(ApplicantService).map(
        (service) => `/applicant-services/${service.toLowerCase()}/order/edit/${order.orderCode}`
    );
    const getChatikLink = useChatikLink();

    let Component = STATUS_COMPONENT_MAP[orderStatus];
    if (availableEditUrls.includes(pathname)) {
        Component = EditRequest;
    }
    return (
        <>
            {order.chatId && (
                <Column xs="4" s="6" m="9" l="11" container>
                    <Text>
                        <div className={styles.chatikLink}>
                            {formatToReactComponent(trls[TrlKeys.chatikText], {
                                '{0}': (
                                    <SPALink to={getChatikLink(order.chatId)} target="_blank" inline>
                                        {trls[TrlKeys.chatikLink]}
                                    </SPALink>
                                ),
                            })}
                        </div>
                    </Text>
                    <VSpacing base={4} />
                </Column>
            )}
            <Component />
        </>
    );
};

export default translation(CareerServiceOrder);
